// extracted by mini-css-extract-plugin
module.exports = {"root":"ReactionButton_root_1hb5V","root--disabled":"ReactionButton_root--disabled_27OV_"};